import {Component, OnInit} from '@angular/core';
import {HttpService} from '../service/http.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-guide-page-info',
  templateUrl: './guide-page-info.component.html',
  styleUrls: ['./guide-page-info.component.css']
})
export class GuidePageInfoComponent implements OnInit {

  leadershipList: any[] = [];

  constructor(private http: HttpService,
              private router: Router,
              public translate: TranslateService) {
  }

  ngOnInit(): void {
    this.getLeadershipByCity();
  }

  getLeadershipByCity() {
    this.http.getKazLeadership().subscribe((data: any) => {
      this.leadershipList = data;
    });
  }

  redirectGuideItem(item) {
    this.router.navigate(['/leadership', item.id]);

  }
}
